export function isAlphabet(string) {
  const pattern = /^[A-Za-z]*$/;
  return pattern.test(string);
}
